import { allBuiltInTools } from 'hooks/usePreferences/allTools';
import type { ActiveToolContext } from './types';

/**
 * Build context for the currently selected tool without triggering network calls.
 *
 * Uses allBuiltInTools to resolve tool metadata synchronously.
 * For SDK tools or unknown tool IDs, returns a minimal context with just the tool_id.
 */
export function buildActiveToolContext(toolId: string): ActiveToolContext {
  const tool = Object.values(allBuiltInTools).find((t) => t.id === toolId);

  if (tool) {
    return {
      tool_id: toolId,
      tool_name: tool.description || tool.name || null,
      category: tool.category || null,
    };
  }

  return {
    tool_id: toolId,
    tool_name: null,
    category: null,
  };
}
